import { useCurrentAccountId } from "@zapier/identity";
import { useCurrentUser } from "../user/useCurrentUser";
import { DEFAULT_FOLDER_ID, FOLDER_TRASH_ID } from "@zapier/utils";

export default function useVirtualFolders() {
  const accountId = useCurrentAccountId();
  const { user } = useCurrentUser();

  const trashFolder = {
    accountId: accountId as number,
    id: FOLDER_TRASH_ID,
    isShared: false,
    name: "Trash",
    ownerId: undefined,
    parentId: undefined,
    rootId: undefined,
  };

  const defaultPersonalFolder = {
    accountId: accountId as number,
    id: DEFAULT_FOLDER_ID,
    isShared: false,
    name: `${user?.firstName} ${user?.lastName} (Personal)`,
    ownerId: user?.id,
    parentId: undefined,
    rootId: undefined,
  };

  return {
    defaultPersonalFolder,
    trashFolder,
  };
}
